import { Logger, ServiceAuthType, ServiceAuthTypeMap } from '@uploadcam/common';
import { GenerateAuthSecurityTokensInteractor } from './generate-auth-security-tokens.interactor';

export const AUTH_STATE = 'uploadcam_auth_state';
export const PKCE_VERIFIER = 'uploadcam_pkce_verifier';

/**
 * Init Login with redirect flow
 */
export interface LoginWithRedirectAdapterInteractor {
  execute(state: string, pkceChallenge: string, authTypeChanged: boolean): Promise<void>;
}

export class LoginWithRedirectInteractor {
  constructor(
    private readonly generateAuthSecurityTokens: GenerateAuthSecurityTokensInteractor,
    private readonly logger: Logger,
    private readonly loginWithRedirectAdapter: ServiceAuthTypeMap<LoginWithRedirectAdapterInteractor>,
    private readonly storage: Storage,
  ) {}

  public async execute(authType: ServiceAuthType, authTypeChanged: boolean): Promise<void> {
    this.logger.log(`Start login with: ${authType}`);

    const loginWithRedirectAdapter = this.loginWithRedirectAdapter[authType];
    const securityTokens = await this.generateAuthSecurityTokens.execute();

    this.storage.setItem(AUTH_STATE, securityTokens.state);
    this.storage.setItem(PKCE_VERIFIER, securityTokens.pkceVerifier);

    this.logger.log(`Redirecting…`);

    await loginWithRedirectAdapter.execute(
      securityTokens.state,
      securityTokens.pkceChallenge,
      authTypeChanged,
    );
  }
}
